import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { allFinishedWithSuccess, anyRequestsFailed } from '../utils/requestUtils';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
class LoadingWrapper extends PureComponent {
  render() {
    const {
      children,
      requestStatuses
    } = this.props;
    if (allFinishedWithSuccess(...requestStatuses) || anyRequestsFailed(...requestStatuses)) {
      return /*#__PURE__*/_jsx("div", {
        children: children
      });
    }
    return /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      minBlockSize: "300px",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered"
      })
    });
  }
}
LoadingWrapper.propTypes = {
  children: PropTypes.node,
  requestStatuses: PropTypes.array.isRequired
};
export default LoadingWrapper;